export const GET_TRANSACTIONS = "GET_TRANSACTION"
export const GET_TRANSACTIONS_SUCCESS = "GET_TRANSACTIONS_SUCCESS"
export const GET_TRANSACTIONS_FAIL = "GET_TRANSACTIONS_FAIL"

export const GET_TRANSACTION_EXCEL = "GET_TRANSACTION_EXCEL"
export const GET_TRANSACTION_EXCEL_SUCCESS = "GET_TRANSACTION_EXCEL_SUCCESS"
export const GET_TRANSACTION_EXCEL_FAIL = "GET_TRANSACTION_EXCEL_FAIL"

export const GET_ENG_INVOICE_REPORT = "GET_ENG_INVOICE_REPORT"
export const GET_ENG_INVOICE_REPORT_SUCCESS = "GET_ENG_INVOICE_REPORT_SUCCESS"
export const GET_ENG_INVOICE_REPORT_FAIL = "GET_ENG_INVOICE_REPORT_FAIL"


export const GET_INVOICES = "GET_INVOICES"
export const GET_ENG_INVOICES = "GET_ENG_INVOICES"
export const GET_INVOICES_SUCCESS = "GET_INVOICES_SUCCESS"
export const GET_INVOICES_FAIL = "GET_INVOICES_FAIL"

export const POST_PAYMENT_CUSTOM = "POST_PAYMENT_CUSTOM"
export const POST_PAYMENT_CUSTOM_SUCCESS = "POST_PAYMENT_CUSTOM_SUCCESS"
export const POST_PAYMENT_CUSTOM_FAIL = "POST_PAYMENT_CUSTOM_FAIL"

export const GET_ENG_WORK = "GET_ENG_WORK"
export const GET_ENG_WORK_SUCCESS = "GET_ENG_WORK_SUCCESS"
export const GET_ENG_WORK_FAIL = "GET_ENG_WORK_FAIL"


export const RESET_ACCOUNTING_FLAG = "RESET_ACCOUNTING_FLAG"